import { render } from "./famousCourseUploadVideo.vue?vue&type=template&id=daa1ce40&scoped=true"
import script from "./famousCourseUploadVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseUploadVideo.vue?vue&type=script&lang=js"

import "./famousCourseUploadVideo.vue?vue&type=style&index=0&id=daa1ce40&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa1ce40"]])

export default __exports__